import React from "react";
import { CcButton } from "../mui";
import { cx } from "../utils";

/**
 * CcResidentAlertsPagination — page controls for resident-grouped alert review lists.
 * Pagination applies to resident groups, not individual alerts.
 */
const CcResidentAlertsPagination = ({
  currentPage = 1,
  lastPage = 1,
  total = 0,
  perPage = 10,
  onPageChange,
  entityLabel = "residents",
  loading = false,
  className,
}) => {
  if (total <= 0 && !loading) return null;

  const safeLastPage = Math.max(1, lastPage || 1);
  const safeCurrentPage = Math.min(Math.max(1, currentPage), safeLastPage);
  const rangeStart = total === 0 ? 0 : (safeCurrentPage - 1) * perPage + 1;
  const rangeEnd = total === 0 ? 0 : Math.min(safeCurrentPage * perPage, total);
  const canGoPrev = safeCurrentPage > 1 && !loading;
  const canGoNext = safeCurrentPage < safeLastPage && !loading;

  return (
    <nav
      className={cx("cc-resident-alerts-pagination", className)}
      aria-label={`${entityLabel} pagination`}
    >
      <p className="cc-resident-alerts-pagination__summary">
        {total === 0 ? (
          <>No {entityLabel} to show</>
        ) : (
          <>
            Showing{" "}
            <strong>
              {rangeStart}–{rangeEnd}
            </strong>{" "}
            of <strong>{total}</strong> {entityLabel}
          </>
        )}
      </p>

      <div className="cc-resident-alerts-pagination__controls">
        <CcButton
          variant="secondary"
          size="sm"
          disabled={!canGoPrev}
          onClick={() => onPageChange?.(safeCurrentPage - 1)}
        >
          Previous
        </CcButton>

        <span className="cc-resident-alerts-pagination__page">
          Page {safeCurrentPage} of {safeLastPage}
        </span>

        <CcButton
          variant="secondary"
          size="sm"
          disabled={!canGoNext}
          onClick={() => onPageChange?.(safeCurrentPage + 1)}
        >
          Next
        </CcButton>
      </div>
    </nav>
  );
};

export default CcResidentAlertsPagination;
